// 危险废物标签
<template>
  <div class="mapwrap-was" v-if="isRefresh">
    <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" v-if="tabData.length>1" @tab-click="handleRefresh()" stretch>
        <el-tab-pane v-for="(tabDataItem, tabDataIndex) in tabData" :key="tabDataIndex"
          :label="tabDataItem.tabTitle" :name="tabDataItem.tabIndex"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- table -->
    <!-- <div class="searchInput" v-if="tabDataCrt.tabType === 'table' && tabDataCrt.tabTitle === '危险废物贮存分区标志'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="getPic">导出危险废物贮存分区标志</el-button>
    </div> -->
    <!-- <div class="searchInput" v-if="tabDataCrt.tabType === 'table' && tabDataCrt.tabTitle !== '危险废物贮存分区标志'"> -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'table'">
      <el-button v-if="tabDataCrt.tabTitle !== '危险废物贮存分区标志'" class="btnRefresh" type="primary" size="mini" @click="addRow">新增</el-button>
      <el-button v-if="tabDataCrt.tabTitle === '危险废物贮存分区标志'" class="btnRefresh" type="primary" size="mini" @click="getPic">导出危险废物贮存分区标志</el-button>
      <el-button v-if="tabDataCrt.tabTitle === '危险废物标签'" class="btnRefresh" type="primary" size="mini" @click="uploadTable">上传标签</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <!-- <div class="mainTable" v-if="tabDataCrt.tabType === 'table' && tabDataCrt.tabTitle !== '危险废物贮存分区标志'"> -->
    <div class="mainTable" v-if="tabDataCrt.tabType === 'table'">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">
            {{tabDataCrt.tableNames[thi]}}
          </th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{tri+1}}</td>
          <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button type="text" size="mini" @click="editRow(tr)">编辑</el-button>
            <el-button type="text" size="mini" @click="saveRow(tr)">保存</el-button>
            <el-button type="text" size="mini" @click="deleteRow(tr)">删除</el-button>
            <el-button v-if="tabDataCrt.tabTitle !== '危险废物贮存分区标志'" type="text" size="mini" @click="leadingOut(tr, tabDataCrt.api.extraParam.type)">导出</el-button>
            <el-button v-if="tabDataCrt.tabTitle === '危险废物标签'" type="text" size="mini" @click="leadingOutAll(tr)">批量生成</el-button>
            <el-button v-if="tabDataCrt.tabTitle === '危险废物标签'" type="text" size="mini" @click="daida(tr)">申请打印</el-button>
          </td>
        </tr>
      </table>
    </div>
    <!-- multiform -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'multiform'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="editForm()">编辑</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="saveForm()">保存</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'multiform'">
      <table class="listTable" width="100%" border="1" align="center">
        <!-- <tr>
          <th class="cell thtitle" width="25%" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
        </tr> -->
        <tr v-for="(tr, tri) in tabDataCrt.multiformData" :key="tri">
          <td class="cell tdcell" width="25%" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tabDataCrt.editable && !tr.editFlag && td !== 'name'" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <!-- <div class="bottom-pagination" v-if="tabDataCrt.tabTitle !== '危险废物贮存分区标志'"> -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      :visible="showWasteFlag"
      title="数据详情"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <div v-if="this.tabDataCrt.api.extraParam.type === 1">
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物名称：</span><el-input v-model="name" placeholder="请输入废物名称"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物种类：</span><el-input v-model="category" placeholder="请输入废物种类"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物代码：</span><el-input v-model="wasteCode" placeholder="请输入废物代码"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物形态：</span><el-input v-model="wasteForm" placeholder="请输入废物形态"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">主要成分：</span><el-input v-model="basis" placeholder="请输入主要成分"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">有害成分：</span><el-input v-model="hazardousIngredients" placeholder="请输入有害成分"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">注意事项：</span><el-input v-model="note" placeholder="请输入注意事项"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">单位编码：</span><el-input v-model="number1" placeholder="请输入单位编码"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 11%;font-size: 18px;">危废代码：</span>
          <el-input style="width: 40%;" v-model="number2" placeholder="请输入危废代码" @change="changeList(number2)"></el-input>
          <select style="width: 20%;" v-model="number2" placeholder="请选择">
            <option v-for="(item, index) in number2List" :key="index" :label="item.code" :value="item.code">{{item.code}}</option>
          </select>
        </div>
        <div style="color: rgb(64, 158, 255);margin: 0 12% 0 10px">
          <p>tips：可以直接在输入框中输入8位危废代码，也可以输入连续的几位代码后，点击输入框后面的选择框进行选择哦!!</p>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">日期码：</span><el-input v-model="number3" placeholder="请输入日期码"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">危废顺序码：</span><el-input v-model="number4" placeholder="请输入危废顺序码"></el-input>
        </div>
        <div style="color: rgb(64, 158, 255);margin: 0 12% 0 10px">tips：
          <p>1、数字识别码组成为：18位单位编码 + 8位危废代码 + 8位日期码 + 3位危废顺序码；</p>
          <p>2、18位单位编码为单位营业执照上的社会信用代码；</p>
          <p>3、8位危废代码采用《国家危险废物名录》中危废代码的数字部分，如90004149，可在小智的发现页中的危废名录中查询；</p>
          <p>4、8位日期码为危险废物产生日期中的数字部分，采用年月日的格式顺序，如 20210101；</p>
          <p>5、3位危废顺序码为危险废物标签设置单位内部自行设置的 3 位数字编号，按顺序设为 001～999。</p>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">产生/收集单位：</span><el-input v-model="creatingUrnits" placeholder="请输入产生/收集单位"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">联系人和联系方式：</span><el-input v-model="contacts" placeholder="请输入联系人和联系方式"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">产生日期：</span><el-input v-model="generationDate" placeholder="请输入联系人和联系方式"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物重量：</span><el-input v-model="weight" placeholder="请输入废物重量"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">备注：</span><el-input v-model="remarks" placeholder="请输入备注"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">危险特性警示图形类别：</span>
          <el-input v-model="hazardCharacteristics" placeholder="请输入"></el-input>
          <!-- <label><input name="苹果" v-model="hazardCharacteristics" type="checkbox" value="苹果" />苹果 </label>
          <label><input name="桃子" v-model="hazardCharacteristics" type="checkbox" value="桃子" />桃子 </label>
          <label><input name="香蕉" v-model="hazardCharacteristics" type="checkbox" value="香蕉" />香蕉 </label>
          <label><input name="梨" v-model="hazardCharacteristics" type="checkbox" value="梨" />梨 </label> -->
        </div>
        <div style="color: rgb(64, 158, 255);margin: 0 12% 0 10px">tips：
          <p>1、危险特性警示图形类别分为:腐蚀性,毒性,易燃性,反应性四类；</p>
          <p>2、多种类之间需要用逗号隔开哦。</p>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 11%;font-size: 18px;">尺寸(mm)：</span>
          <!-- <span v-if="sizeOne !== ''" style="width: 11%;font-size: 18px;">{{ sizeOne }}</span> -->
          <select style="width: 20%;" v-model="sizeOne" placeholder="请选择">
            <option v-for="(item, index) in sizeOptions" :key="index" :label="item.label" :value="item.value">{{item.label}}</option>
          </select>
        </div>
      </div>
      <div v-if="this.tabDataCrt.api.extraParam.type === 3 || this.tabDataCrt.api.extraParam.type === 4 || this.tabDataCrt.api.extraParam.type === 5">
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">单位名称：</span><el-input v-model="unitName" placeholder="请输入单位名称"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">设施编码：</span><el-input v-model="facilityCode" placeholder="请输入设施编码"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">负责人及联系方式：</span><el-input v-model="contactInformation" placeholder="请输入负责人及联系方式"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物名称：</span><el-input v-model="name" placeholder="请输入废物名称"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">废物种类：</span><el-input v-model="category" placeholder="请输入废物种类"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">备注：</span><el-input v-model="remarks" placeholder="请输入备注"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 11%;font-size: 18px;">版式：</span>
          <!-- <span v-if="format !== ''" style="width: 11%;font-size: 18px;">{{ format }}</span> -->
          <select style="width: 20%;" v-model="format" placeholder="请选择">
            <option v-for="(item, index) in formatOptions" :key="index" :label="item.label" :value="item.value">{{item.label}}</option>
          </select>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 11%;font-size: 18px;">尺寸(mm):</span>
          <!-- <span v-if="sizeOne !== ''" style="width: 11%;font-size: 18px;">{{ sizeOne }}</span> -->
          <select style="width: 20%;" v-model="sizeOne" placeholder="请选择">
            <option v-for="(item, index) in sizeOptions1" :key="index" :label="item.label" :value="item.value">{{item.label}}</option>
          </select>
        </div>
      </div>
      <div v-if="this.tabDataCrt.api.extraParam.type === 2">
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">分区序号：</span><el-input v-model="subregion1" placeholder="请输入分区序号"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">危废类别（编辑时按回车键即可换行）：</span><el-input type="textarea" v-model="subregion2" placeholder="请输入危废类别"></el-input>
        </div>
      </div>
      <el-button type="primary" @click="closeIt()" size="medium" style="width: 88px; height: 36px;">关闭</el-button>
      <el-button type="primary" @click="cleanIt()" size="medium" style="width: 88px; height: 36px;">重置</el-button>
      <el-button type="primary" @click="submitUnit()" size="medium" style="width: 88px; height: 36px;">提交</el-button>
    </nut-dialog>
    <nut-dialog
      :visible="showNumberFlag"
      title="批量生成详情"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <div style="display: flex;margin-top: 6px;">
        <span style="width: 12%;font-size: 18px;">份数：</span><el-input v-model="numberWord" placeholder="请输入份数（数字，如 12）"></el-input>
      </div>
      <div style="color: rgb(64, 158, 255);margin: 0 12% 0 10px">
        <p>tips：请输入导出的份数，50份以上会导致小智导出变慢!!</p>
      </div>
      <el-button type="primary" @click="closeNumber()" size="medium" style="width: 88px; height: 36px;">关闭</el-button>
      <el-button type="primary" @click="submitNumber()" size="medium" style="width: 88px; height: 36px;">提交</el-button>
    </nut-dialog>
    <nut-dialog
      :visible="showDaYinFlag"
      title="小智打印说明"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">打印份数：</span>
          <input style="font-size: 18px;" type="number" id="numberOne1" min="1" :value="numberOne">
          <!-- <span style="width: 12%;font-size: 18px;">打印份数（只允许输入整数）：</span><el-input v-model="numberOne" placeholder="请输入打印份数"></el-input> -->
        </div>
        <div v-if="valueDYType === false" style="display: flex;margin-top: 6px;">
          <!-- <span style="width: 12%;font-size: 18px;">收货地址（市）：</span><el-input v-model="city" placeholder="请输入市"></el-input> -->
          <span style="width: 11%;font-size: 18px;">是否需要赠送一张：</span>
          <select style="width: 20%;" v-model="isSend" placeholder="请选择">
            <option v-for="(item, index) in isSendList" :key="index" :label="item.lable" :value="item.value">{{item.lable}}</option>
          </select>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">收件人姓名：</span><el-input v-model="userName" placeholder="请输入收件人姓名"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">收件人手机号：</span><el-input v-model="phoneOne" placeholder="请输入收件人手机号"></el-input>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 11%;font-size: 18px;">收货地址（省）：</span>
          <select style="width: 20%;" v-model="province" placeholder="请选择省" @change="citySearch(province)">
            <option v-for="(item, index) in provinceList" :key="index" :label="item.pro" :value="item.pro">{{item.pro}}</option>
          </select>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <!-- <span style="width: 12%;font-size: 18px;">收货地址（市）：</span><el-input v-model="city" placeholder="请输入市"></el-input> -->
          <span style="width: 11%;font-size: 18px;">收货地址（市）：</span>
          <select style="width: 20%;" v-model="city" placeholder="请选择省">
            <option v-for="(item, index) in cityList" :key="index" :label="item.city || item.area" :value="item.city || item.area">{{item.city || item.area}}</option>
          </select>
        </div>
        <div style="display: flex;margin-top: 6px;">
          <span style="width: 12%;font-size: 18px;">详细地址：</span><el-input v-model="placeInfo" placeholder="请输入详细地址"></el-input>
        </div>
      </div>
      <p style="font-weight: bold;margin-top: 10px;">打印说明:</p>
      <div v-for="(itemB, index) in wordList" :key="index">
        <div style="justify-content: space-between;margin-top: 5px;">
          <div>
            {{ itemB }}
          </div>
        </div>
      </div>
      <el-button type="primary" @click="closeDy()" size="medium" style="width: 88px; height: 36px;">关闭</el-button>
      <el-button type="primary" @click="subscribeDy()" size="medium" style="width: 88px; height: 36px;">提交</el-button>
    </nut-dialog>
    <nut-dialog
      :visible="subrPriceFlag"
      title="确定是否需要打印？"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <span>{{ textDY }}</span>
      <div align="center">
        <el-button type="primary" @click="cancel" style="width:100px;height:36px;margin-top: 10px">取消</el-button>
        <el-button type="primary" @click="dealSure" style="width:100px;height:36px;margin-top: 10px">确定</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      :visible="dialogVisible"
      title="确定是否需要打印？"
      :closeOnClickModal="false"
      :closeBtnr="true"
      :noFooter="true">
      <p style="margin: 0 0 10px 0">您的环境豆数量不足，请确定是否需要充值</p>
      <div align="center">
        <el-button type="primary" @click="passSurePay" style="width:100px;height:36px;">取消</el-button>
        <el-button type="primary" @click="makeSurePay" style="width:100px;height:36px;">确定</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="importFlag = false"
      v-if="importFlag"
      :visible="importFlag"
      title="'上传标签'"
      :noFooter="true">
      <ehsTableImport
        ref="uploadRef"
        :btnName="'上传'"
        :uploadMethod="'hbHazardousLabelUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload">
      </ehsTableImport>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/index'
import ehsTableImport from '../../H5pages/ehs-com/ehsTableImport.vue'
export default {
  data () {
    return {
      extaParam: {},
      importFlag: false,
      phone: JSON.parse(sessionStorage.getItem('qs_phone') || '未登录'),
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '危险废物标签',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '废物名称',
            '废物种类',
            '废物代码',
            '废物形态',
            '主要成分',
            '有害成分',
            '注意事项',
            '单位编码：',
            '危废代码',
            '日期码',
            '危废顺序码',
            '数字识别码',
            '产生/收集单位',
            '联系人和联系方式',
            '产生日期',
            '废物重量',
            '备注',
            '危险特性警示图形类别',
            '尺寸（mm）'
          ],
          rowItems: [
            'name',
            'category',
            'wasteCode',
            'wasteForm',
            'basis',
            'hazardousIngredients',
            'note',
            'number1',
            'number2',
            'number3',
            'number4',
            'identificationCode',
            'creatingUrnits',
            'contacts',
            'generationDate',
            'weight',
            'remarks',
            'hazardCharacteristics',
            'size'
          ],
          api: {
            add: 'hbHazardousLabelAdd',
            enquiry: 'hbHazardousLabelEnquiry',
            update: 'hbHazardousLabelUpdate',
            delete: 'hbHazardousLabelDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '危险废物贮存分区标志',
          tabIndex: 'tabB',
          tabType: 'table',
          tableNames: [
            '分区序号',
            '危废类别'
          ],
          rowItems: [
            'subregion1',
            'subregion2'
          ],
          api: {
            add: 'hbHazardousLabelAdd',
            enquiry: 'hbHazardousLabelEnquiry',
            update: 'hbHazardousLabelUpdate',
            delete: 'hbHazardousLabelDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '危险废物贮存设施',
          tabIndex: 'tabC',
          tabType: 'table',
          tableNames: [
            '单位名称',
            '设施编码',
            '负责人及联系方式',
            '废物名称',
            '废物种类',
            '备注',
            '版式',
            '尺寸(mm)'
          ],
          rowItems: [
            'unitName',
            'facilityCode',
            'contactInformation',
            'name',
            'category',
            'remarks',
            'format',
            'size'
          ],
          api: {
            add: 'hbHazardousLabelAdd',
            enquiry: 'hbHazardousLabelEnquiry',
            update: 'hbHazardousLabelUpdate',
            delete: 'hbHazardousLabelDelete',
            extraParam: {
              type: 3
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '危险废物利用设施',
          tabIndex: 'tabD',
          tabType: 'table',
          tableNames: [
            '单位名称',
            '设施编码',
            '负责人及联系方式',
            '废物名称',
            '废物种类',
            '备注',
            '版式',
            '尺寸(mm)'
          ],
          rowItems: [
            'unitName',
            'facilityCode',
            'contactInformation',
            'name',
            'category',
            'remarks',
            'format',
            'size'
          ],
          api: {
            add: 'hbHazardousLabelAdd',
            enquiry: 'hbHazardousLabelEnquiry',
            update: 'hbHazardousLabelUpdate',
            delete: 'hbHazardousLabelDelete',
            extraParam: {
              type: 4
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '危险废物处置设施',
          tabIndex: 'tabE',
          tabType: 'table',
          tableNames: [
            '单位名称',
            '设施编码',
            '负责人及联系方式',
            '废物名称',
            '废物种类',
            '备注',
            '版式',
            '尺寸(mm)'
          ],
          rowItems: [
            'unitName',
            'facilityCode',
            'contactInformation',
            'name',
            'category',
            'remarks',
            'format',
            'size'
          ],
          api: {
            add: 'hbHazardousLabelAdd',
            enquiry: 'hbHazardousLabelEnquiry',
            update: 'hbHazardousLabelUpdate',
            delete: 'hbHazardousLabelDelete',
            extraParam: {
              type: 5
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      hhobbies: ['腐蚀性', '毒性', '易燃性', '反应性'],
      numList: ['00000000', '11', '22', '33'],
      isRefresh: true,
      showWasteFlag: false,
      name: '',
      category: '',
      wasteCode: '',
      wasteForm: '',
      basis: '',
      hazardousIngredients: '',
      note: '',
      number1: '',
      number2: '',
      number3: '',
      number4: '',
      identificationCode: '',
      creatingUrnits: '',
      contacts: '',
      generationDate: '',
      weight: '',
      remarks: '',
      hazardCharacteristics: '',
      unitName: '',
      facilityCode: '',
      contactInformation: '',
      subregion1: '',
      subregion2: '',
      typeNew: 0,
      wordType: 0,
      wordForm: {},
      number2List: [],
      number1New: '',
      number2New: '',
      number3New: '',
      number4New: '',
      showNumberFlag: false,
      numberId: 1,
      numberWord: 1,
      showDaYinFlag: false,
      dYId: 0,
      provinceList: [],
      cityList: [],
      price: 0,
      numberOne: 1,
      priceOne: 0,
      province: '',
      city: '',
      wordList: [],
      placeInfo: '',
      subrPriceFlag: false,
      dialogVisible: false,
      uploadDetection: false,
      numberDYAll: 0,
      textDY: '',
      valueDYType: false,
      valueDY: false,
      userName: '',
      phoneOne: '',
      isSend: '',
      isSendList: [{
        id: 1,
        lable: '是',
        value: true
      }, {
        id: 2,
        lable: '否',
        value: false
      }],
      sizeOne: '',
      format: '',
      sizeOptions: [{
        label: '100*100',
        value: '100'
      }, {
        label: '150*150',
        value: '150'
      }, {
        label: '200*200',
        value: '200'
      }],
      sizeOptions1: [{
        label: '300*186',
        value: '300'
      }, {
        label: '600*372',
        value: '600'
      }, {
        label: '900*558',
        value: '900'
      }],
      formatOptions: [{
        label: '横版',
        value: '横版'
      }, {
        label: '竖版',
        value: '竖版'
      }]
    }
  },
  mounted () {
    console.log('phone', this.phone)
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
  },
  methods: {
    uploadTable () {
      this.extaParam = { phone: this.phone }
      this.importFlag = true
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    handleSuccess () {
      this.$toast.text('上传成功')
      this.importFlag = false
      this.getTabData()
    },
    getNewInfo () {
      api.hbHazardousLabelInformation({
        phone: this.phone
      }).then(res => {
        console.log(res)
        this.number1New = res.data.number1
        this.number3New = res.data.number3
        this.number4New = res.data.number4
        this.number1 = res.data.number1
        this.number3 = res.data.number3
        this.number4 = res.data.number4
      })
    },
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          phone: this.phone,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      console.log(this.tabType)
      this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTabData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    // addRow () {
    //   if (this.tabDataCrt.tabType === 'table') {
    //     var date = new Date()
    //     var thatYear = date.getFullYear()
    //     var thatMonth = date.getMonth() + 1
    //     var thatDay = date.getDate()
    //     var thatDate = thatYear + '-' + thatMonth + '-' + thatDay
    //     console.log('thatDate', thatDate)
    //     var savePusherAdd = {
    //       ...this.tabDataCrt.api.extraParam
    //     }
    //     this.tabDataCrt.rowItems.forEach(rowItem => {
    //       console.log(rowItem)
    //       if (rowItem === 'hazardCharacteristics') {
    //         savePusherAdd[rowItem] = '腐蚀性,毒性,易燃性,反应性'
    //       } else if (rowItem === 'generationDate') {
    //         savePusherAdd[rowItem] = thatDate
    //       } else {
    //         savePusherAdd[rowItem] = ''
    //       }
    //     })
    //     console.log('savePusherAdd', savePusherAdd)
    //     api[this.tabDataCrt.api.add]({
    //       phone: this.phone,
    //       ...this.tabDataCrt.api.extraParam,
    //       ...savePusherAdd
    //     }).then(res => {
    //       console.log(res)
    //       this.$nextTick(() => {
    //         this.isRefresh = true
    //         this.pageNo = 1
    //         this.getTabData()
    //       })
    //     })
    //   }
    // },
    addRow () {
      this.wordType = 1
      this.typeNew = this.tabDataCrt.api.extraParam.type
      var date = new Date()
      var thatYear = date.getFullYear()
      var thatMonth = date.getMonth() + 1
      var thatDay = date.getDate()
      var thatDate = thatYear + '-' + thatMonth + '-' + thatDay
      this.generationDate = thatDate
      this.getNewInfo()
      console.log('thatDate', thatDate)
      api.hbHazardousLabelCode({
      }).then(res => {
        console.log(res)
        this.number2List = res.data.number1
      })
      this.hazardCharacteristics = '腐蚀性,毒性,易燃性,反应性'
      this.showWasteFlag = true
    },
    changeList (number2) {
      console.log('this.hazardCharacteristics', this.hazardCharacteristics)
      api.hbHazardousLabelCode({
        code: number2
      }).then(res => {
        console.log(res)
        this.number2List = res.data.number1
      })
    },
    closeIt () {
      this.showWasteFlag = false
    },
    cleanIt () {
      this.name = ''
      this.category = ''
      this.wasteCode = ''
      this.wasteForm = ''
      this.basis = ''
      this.hazardousIngredients = ''
      this.note = ''
      this.number1 = ''
      this.number2 = ''
      this.number3 = ''
      this.number4 = ''
      this.identificationCode = ''
      this.creatingUrnits = ''
      this.contacts = ''
      this.generationDate = ''
      this.weight = ''
      this.remarks = ''
      this.hazardCharacteristics = ''
      this.unitName = ''
      this.facilityCode = ''
      this.contactInformation = ''
      this.wordForm = {}
    },
    submitUnit () {
      if (this.number4 !== this.number4New && this.tabDataCrt.api.extraParam.type === 1 && this.wordType === 1) {
        console.log('fsdfasfsafds')
        var that = this
        this.$dialog({
          title: '您当前填写的危废顺序码和最新的危废顺序码不一致，是否继续提交',
          closeBtn: true,
          onOkBtn (event) {
            this.number4 = this.number4New
            that.endSure()
            this.close()
          },
          onCancelBtn (event) {
            this.close()
          },
          onCloseBtn (event) {
            this.close()
          }
        })
      } else {
        this.endSure()
      }
    },
    endSure () {
      if (this.wordType === 1) {
        api.hbHazardousLabelAdd({
          type: this.typeNew,
          phone: this.phone,
          name: this.name,
          category: this.category,
          wasteCode: this.wasteCode,
          wasteForm: this.wasteForm,
          basis: this.basis,
          hazardousIngredients: this.hazardousIngredients,
          note: this.note,
          number1: this.number1,
          number2: this.number2,
          number3: this.number3,
          number4: this.number4,
          identificationCode: this.number1 + this.number2 + this.number3 + this.number4,
          creatingUrnits: this.creatingUrnits,
          contacts: this.contacts,
          generationDate: this.generationDate,
          weight: this.weight,
          remarks: this.remarks,
          hazardCharacteristics: this.hazardCharacteristics,
          unitName: this.unitName,
          facilityCode: this.facilityCode,
          contactInformation: this.contactInformation,
          subregion2: this.subregion2,
          subregion1: this.subregion1,
          size: this.sizeOne
        }).then(res => {
          console.log(res)
          this.$nextTick(function () {
            this.getTabData()
          })
        })
      } else if (this.wordType === 2) {
        api.hbHazardousLabelUpdate({
          phone: this.phone,
          id: this.wordForm.id,
          name: this.name,
          category: this.category,
          wasteCode: this.wasteCode,
          wasteForm: this.wasteForm,
          basis: this.basis,
          hazardousIngredients: this.hazardousIngredients,
          note: this.note,
          number1: this.number1,
          number2: this.number2,
          number3: this.number3,
          number4: this.number4,
          identificationCode: this.number1 + this.number2 + this.number3 + this.number4,
          creatingUrnits: this.creatingUrnits,
          contacts: this.contacts,
          generationDate: this.generationDate,
          weight: this.weight,
          remarks: this.remarks,
          hazardCharacteristics: this.hazardCharacteristics,
          unitName: this.unitName,
          facilityCode: this.facilityCode,
          contactInformation: this.contactInformation,
          subregion2: this.subregion2,
          subregion1: this.subregion1,
          size: this.sizeOne
        }).then(res => {
          console.log(res)
          this.$nextTick(function () {
            this.getTabData()
          })
        })
      }
    },
    editRow (row) {
      console.log('row', row)
      this.wordType = 2
      this.wordForm = row
      this.name = this.wordForm.name
      this.category = this.wordForm.category
      this.wasteCode = this.wordForm.wasteCode
      this.wasteForm = this.wordForm.wasteForm
      this.basis = this.wordForm.basis
      this.hazardousIngredients = this.wordForm.hazardousIngredients
      this.note = this.wordForm.note
      this.number1 = this.wordForm.number1
      this.number2 = this.wordForm.number2
      this.number3 = this.wordForm.number3
      this.number4 = this.wordForm.number4
      this.identificationCode = this.wordForm.number1 + this.wordForm.number2 + this.wordForm.number3 + this.wordForm.number4
      this.creatingUrnits = this.wordForm.creatingUrnits
      this.contacts = this.wordForm.contacts
      this.generationDate = this.wordForm.generationDate
      this.weight = this.wordForm.weight
      this.remarks = this.wordForm.remarks
      this.hazardCharacteristics = this.wordForm.hazardCharacteristics
      this.unitName = this.wordForm.unitName
      this.facilityCode = this.wordForm.facilityCode
      this.contactInformation = this.wordForm.contactInformation
      this.subregion1 = this.wordForm.subregion1
      this.subregion2 = this.wordForm.subregion2
      this.format = this.wordForm.format
      this.sizeOne = this.wordForm.size
      // if (this.tabDataCrt.api.extraParam.type === 1) {
      //   console.log('fsfsdfsd', this.wordForm.size)
      //   if (this.wordForm.size === '100') {
      //     this.sizeOne = '100*100'
      //   } else if (this.wordForm.size === '150') {
      //     this.sizeOne = '150*150'
      //   } else if (this.wordForm.size === '200') {
      //     this.sizeOne = '200*200'
      //   }
      // } else {
      //   if (this.wordForm.size === '300') {
      //     this.sizeOne = '300*186'
      //   } else if (this.wordForm.size === '600') {
      //     this.sizeOne = '600*372'
      //   } else if (this.wordForm.size === '900') {
      //     this.sizeOne = '900*558'
      //   }
      // }
      this.showWasteFlag = true
      // row.editFlag = true
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update]({
          phone: this.phone,
          ...savePusher
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    getPic () {
      api.hbHazardousLabelDerive({
        phone: this.phone,
        type: 2
      }).then(res => {
        console.log(res)
        window.open(res.data.url)
      })
    },
    leadingOut (row, type) {
      console.log('row', row)
      api.hbHazardousLabelDerive({
        type: type,
        id: row.id
      }).then(res => {
        console.log(res)
        window.open(res.data.url)
      })
    },
    leadingOutAll (row) {
      this.numberId = row.id
      this.showNumberFlag = true
    },
    closeNumber () {
      this.showNumberFlag = false
    },
    submitNumber () {
      api.hbHazardousLabelDeriveOne({
        number: this.numberWord,
        type: 1,
        id: this.numberId
      }).then(res => {
        console.log(res)
        window.open(res.data.url)
      })
    },
    daida (row) {
      this.dYId = row.id
      api.reportReferenceProvince({
        type: 1,
        pid: 0
      }).then(res => {
        this.provinceList = res.data
      })
      api.hbHazardousLabelByPrinted({
        id: row.id,
        idOne: 1,
        phone: this.phone
      }).then(res => {
        this.province = res.data.province ? res.data.province : ''
        this.city = res.data.city ? res.data.city : ''
        this.placeInfo = res.data.placeInfo ? res.data.placeInfo : ''
        this.userName = res.data.userName ? res.data.userName : ''
        this.phoneOne = res.data.phoneOne ? res.data.phoneOne : this.phone
        this.wordList = res.data.list
        this.valueDYType = res.data.sendType
        if (res.data.province) {
          api.reportReferenceProvince({
            type: 1,
            pid: res.data.province
          }).then(resA => {
            this.cityList = resA.data
          })
        }
      })
      this.showDaYinFlag = true
    },
    citySearch (id) {
      if (id !== '') {
        api.reportReferenceProvince({
          type: 1,
          pid: id
        }).then(res => {
          this.cityList = res.data
        })
      }
    },
    closeDy () {
      this.showDaYinFlag = false
    },
    subscribeDy () {
      if (this.userName === '' || this.phoneOne === '' || this.province === '' || this.city === '' || this.placeInfo === '') {
        var beforeMonitorAddConfirm = confirm('请输入收件人姓名、收件人手机号、省、市以及详细地址后再提交哦！')
        if (beforeMonitorAddConfirm) {}
      } else {
        api.hbHazardousLabelByPrinted({
          phone: this.phone,
          phoneOne: this.phoneOne,
          userName: this.userName,
          numberOne: document.getElementById('numberOne1').value,
          province: this.province,
          city: this.city,
          placeInfo: this.placeInfo,
          sendType: this.isSend === true ? this.isSend : false,
          id: this.dYId
        }).then(res => {
          if (res.code === 200) {
            this.textDY = res.data.text
            this.numberDYAll = res.data.priceMoney
            this.numberOne = res.data.printNumber
            this.subrPriceFlag = true
          } else {
            var beforeMonitorAddConfirm = confirm(res.message)
            if (beforeMonitorAddConfirm) {}
          }
        })
      }
    },
    cancel () {
      this.subrPriceFlag = false
    },
    dealSure () {
      api.hbHazardousLabelPrinted({
        phone: this.phone,
        phoneOne: this.phoneOne,
        userName: this.userName,
        numberOne: this.numberOne,
        province: this.province,
        city: this.city,
        placeInfo: this.placeInfo,
        priceMoney: this.numberDYAll,
        sendType: this.isSend === true ? this.isSend : false,
        id: this.dYId
      }).then(res => {
        if (res.code === 200) {
          var beforeMonitorAddConfirm = confirm(res.message)
          if (beforeMonitorAddConfirm) {}
          // this.$message({
          //   showClose: true,
          //   duration: 5000,
          //   type: 'success',
          //   message: res.message
          // })
        } else {
          this.subrPriceFlag = false
          this.dialogVisible = true
        }
      })
    },
    passSurePay () {
      this.dialogVisible = false
    },
    makeSurePay () {
      this.dialogVisible = false
      var routerDataA = this.$router.resolve({
        path: '/H5SearchPage'
      })
      window.open(routerDataA.href, '_blank')
    }
  },
  components: {
    ehsTableImport
    // ehsTableImport
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap-was{
  z-index: 0;
  height: 100%;
  overflow: scroll;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
